import styled from 'styled-components';

export const WorkerBadge = styled.img`
  transform: rotate(-90deg) translateX(-32%);
  scale: 1.5;
`;